import Formsy from 'formsy-react-2';
import React from 'react';
import css from './style.scss'
import cn from 'classnames'
class Select extends Formsy.Mixin {
  updateValue = (event) => {
    this.setValue(event.target.value);
  }

  options(){
    return this.props.options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)
  }

  render() {
    const {options, fullWidth, ...rest} = this.removeFormsyProps(this.props);
    const errorMessage = this.getErrorMessage();
    return (
      <div className={cn(css.input, fullWidth? css.fullWidth : "")}>
        <label>{this.props.label}</label>
        <select {...rest} className={css.select} value={this.getValue()} onChange={this.updateValue}>
          {this.options()}
        </select>
        <span>{errorMessage}</span>
        <small>{this.props.message}</small>
      </div>
    )
  }
}


export default Select;



// WEBPACK FOOTER //
// ./src/components/shared/input/select.js